import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import AOS from "aos";  // Import AOS
import "aos/dist/aos.css";  // Import AOS styles


const BackgroundCircle = styled(Box)(() => ({
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "80%",
    backgroundColor: "#E3EBD4",
    borderRadius: "0 0 60% 60%",
    zIndex: -1, // Place it behind the image
}));

const ResponsiveImage = styled("img")(() => ({
    display: "block",
    width: "90%",
    maxWidth: "1200px", // Restrict maximum width for larger screens
    height: "auto", // Maintain aspect ratio
    margin: "50px auto", // Add top and bottom margins, center horizontally
    borderRadius: "16px", // Rounded corners
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional shadow for better aesthetics
}));

const ParagraphSection = styled(Box)(() => ({
    margin: "20px auto",
    padding: "20px",
    maxWidth: "1000px",
    textAlign: "center", // Center the text
}));

const FoodProductsSection = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Adjust duration as needed
      }, []);
    return (
        <>
            {/* Elliptical Background */}
            <BackgroundCircle data-aos="fade-up" />

            {/* Responsive Image */}
            <ResponsiveImage
                src="https://i.postimg.cc/FHpL7tT0/Frame-1265.png"
                alt="Responsive Design"
                data-aos="zoom-in"
            />

            {/* Paragraph Section */}
            <ParagraphSection>
                <Typography variant="h5"  data-aos="fade-up" sx={{ fontWeight: "bold", marginBottom: 2, color: "#98AF41",fontFamily: '"Montserrat", sans-serif', }}>
                    About My Food Products
                </Typography>
                <Typography variant="body1"  data-aos="fade-up" sx={{ lineHeight: 1.8, color: "#98AF41" }}>
                My Food is a brand that we proudly own and promote. With a wide range of products, we provide necessities including jaya rice, matta short grain, ponni rice, kuruva rice, and honey.
                </Typography>
            </ParagraphSection>
        </>
    );
};

export default FoodProductsSection;
